module.exports = __webpack_public_path__ + "assets/music/epic/City of Sand by Agret Brisignr.ogg";